import React from "react";

const GalaPage = () => {
  window.location.href = "https://gala-anual.hospitalbritanico.org.ar/";
  return null;
};

export default GalaPage;
